import { render, staticRenderFns } from "./AppSubmenu.vue?vue&type=template&id=3e378756&scoped=true"
import script from "./AppSubmenu.vue?vue&type=script&lang=js"
export * from "./AppSubmenu.vue?vue&type=script&lang=js"
import style0 from "./AppSubmenu.vue?vue&type=style&index=0&id=3e378756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e378756",
  null
  
)

export default component.exports